import list from 'src/modules/sound/list/soundListReducers';
import form from 'src/modules/sound/form/soundFormReducers';
import view from 'src/modules/sound/view/soundViewReducers';
import destroy from 'src/modules/sound/destroy/soundDestroyReducers';
import importerReducer from 'src/modules/sound/importer/soundImporterReducers';
import unarchive from 'src/modules/sound/unarchive/soundUnarchiveReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  unarchive,
  importer: importerReducer,
});
